// extracted by mini-css-extract-plugin
module.exports = {"container":"_0cD7V"};